import React from 'react';
import { withRouter } from 'react-router-dom';

import loc from 'sources/locale/loc';
import DownloadButton from 'components/controls/DownloadButton';
import SiteNavbarLink from './SiteNavBarLink';
import styles from './SiteNavBar.scss';

function GuestButtons(props) {
  const { pathname } = props.location;
  return (
    <>
      <SiteNavbarLink
        label={loc('contact-label')}
        path="/contact"
        className={styles.navButton}
      />
      <SiteNavbarLink
        label={loc('terms-label')}
        path="/terms"
        className={styles.navButton}
      />
      <SiteNavbarLink
        label={loc('privacy-label')}
        path="/privacy"
        className={styles.navButton}
      />
      {pathname !== '/' && <DownloadButton className={styles.getAppLink} />}
    </>
  );
}

export default withRouter(GuestButtons);



// WEBPACK FOOTER //
// ./src/components/SiteNavBar/GuestButtons.jsx